module.exports = __webpack_public_path__ + "img/Bilde6.5978ce85.jpg";